export default __webpack_public_path__ + "static/media/loadding-logo.cf2b0c84.svg";